import React, { useState } from 'react';
import Modal from 'sushiweb/Modal';
import Button from 'sushiweb/Button';
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CacheDashboardActions from "../../store/actions/CacheDashboard";
import {Heading} from "../../constants/assets/containers";

const CacheDashboard = ({getCache, setCache, deleteCache}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [operation, setOperation] = useState('');
  const [redis_key, setKey] = useState('');
  const [redis_value, setValue] = useState('');
  const [response, setResponse] = useState(null);
  const [showResponsePopup, setShowResponsePopup] = useState(false);

  const handleButtonClick = (op) => {
    setOperation(op);
    setIsVisible(true);
    setShowResponsePopup(false);
  };

  const handleCsvButtonClick = () => {
    const isprod = process.env.REACT_APP_ENV === 'production';
    if (isprod) {
      const url = 'https://admin.zomans.com/bulkops/';
      window.open(url, '_blank');
    } else {
      console.log('Action available only in production');
    }
  };


  const handleClose = () => {
    setIsVisible(false);
    setOperation('');
    setKey('');
    setValue('');
    setResponse(null);
    setShowResponsePopup(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res;
    
    try {
      if (operation === 'get') {
        res = await getCache(redis_key);
      } else if (operation === 'set') {
        var req = JSON.stringify({redis_key: redis_key, redis_value: redis_value});
        res = await setCache(req);
      } else if (operation === 'delete') {
        res = await deleteCache(redis_key);
      }
      setResponse(res.data);
      setShowResponsePopup(true);
    } catch (error) {
      setResponse(error.message);
      setShowResponsePopup(false);
    }
    setKey('');
    setValue('');
    setIsVisible(false);
  };

  const handleKeyChange = (e) => {
    setKey(e.target ? e.target.value : e);
  };
  
  const handleValueChange = (e) => {
    setValue(e.target ? e.target.value : e);
  };

  const handlePopupClose = () => {
    setShowResponsePopup(false);
  };

  return (
    <div>
      <Heading style={{ marginBottom: '20px' }}>OFS Cache Dashboard</Heading>
      <Button 
        appearance="outline" 
        onClick={() => handleButtonClick('get')}
        style={{ marginRight: '10px' }}
      >
        GET
      </Button>
      <Button 
        appearance="outline" 
        onClick={() => handleButtonClick('set')}
        style={{ marginRight: '10px' }}
      >
        SET
      </Button>
      <Button 
        appearance="outline" 
        onClick={() => handleButtonClick('delete')}
        style={{ marginRight: '10px' }}
      >
        DELETE
      </Button>
      <Button 
        appearance="outline" 
        onClick={handleCsvButtonClick}
        style={{ marginRight: '10px' }}
      >
        Bulk Order State Update
      </Button>

    <Modal visible={isVisible} onClose={handleClose} style={{ width: '10%', height: '10%' }}>
    <div style={{ padding: '20px' }}>
        <Heading style={{ marginBottom: '10px' }}>{operation.toUpperCase()}-CACHE</Heading>
        <div>
            
            <Input
                id="sushi-input"
                label="Redis Key"
                onChange={handleKeyChange}
                value={redis_key}
                required
                autofocus
            />
            
        </div>
        {operation === 'set' && (
            <div>
                <Input
                label="Redis Value"
                id="sushi-input"
                onChange={handleValueChange}
                value={redis_value}
                required
                autofocus
                />
            
            </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
            <Button 
            onClick={(e) => handleSubmit(e)}
            type="submit" 
            style={{ padding: '5px 10px', fontSize: '14px' }}
            >
            Submit
            </Button>
            <Button 
            type="button" 
            onClick={handleClose} 
            style={{ padding: '5px 10px', fontSize: '14px' }}
            >
            Cancel
            </Button>
        </div>
    </div>
    </Modal>

    {showResponsePopup && (
      <Modal visible={showResponsePopup} onClose={handlePopupClose} style={{ width: '10%', height: '10%' }}>
        <div style={{ padding: '20px' }}>
          <Heading>{(operation === 'get' || operation === 'set')?'Success!': 'Successfully deleted'}</Heading>
          {response && (operation === 'get' || operation === 'set') && (
            
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>Key</th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{response.key}</td>
                  <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{response.value}</td>
                </tr>
              </tbody>
            </table>
          )
          }
          <Button 
            type="button" 
            onClick={handlePopupClose} 
            style={{ padding: '10px 5px', fontSize: '14px' }}
          >
            Close
          </Button>
        </div>
      </Modal>
    )}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
    return {
        getCache: bindActionCreators(CacheDashboardActions.getCache, dispatch),
        setCache: bindActionCreators(CacheDashboardActions.setCache, dispatch),
        deleteCache: bindActionCreators(CacheDashboardActions.deleteCache, dispatch),
    }
}

export default connect(null, mapDispatchToProps)(CacheDashboard);